import { AdministrationTab } from "@/app/types/admin/AdministrationTab";
import { URLs } from "@/app/utils/URLs";
import { LOCALES } from "@/app/vars/Languages";
import { UrlParam } from "@/app/vars/Urls";

export const APP_URL = URLs.getServerUrl() || "";

let APP_URL_PREFIX = APP_URL;

if (!APP_URL_PREFIX.endsWith("/")) {
  APP_URL_PREFIX += "/";
}

let locale = LOCALES[0];

if (typeof window !== "undefined") {
  for (const _locale of LOCALES) {
    locale = "";
    const pathname = window.location.pathname || "";
    if (pathname.startsWith(`/${_locale}/`) || pathname === `/${_locale}`) {
      locale = _locale;
      break;
    }
  }
}

APP_URL_PREFIX += locale;

export const PublicPaths = {
  HOME: "/",
  BLOG: "/blog",
} as const;

export const LegalPaths = {
  PRIVACY: "/privacy",
  TERMS: "/terms",
} as const;

export const BlogSlugs = {
  CALL_ANALYSIS_TOOLS: {
    fr: "analyser-appels-vente-outils",
    en: "analysing-sales-calls-tools",
  },
  OFFER_BUILD: {
    fr: "construire-offre-qui-vend",
    en: "build-an-offer-that-sells",
  },
  CLIENT_AVATAR_BUILD: {
    fr: "creer-avatar-client",
    en: "create-a-client-avatar",
  },
  SITUATION_TARGETING: {
    fr: "cibler-situation-plutot-que-profil",
    en: "target-a-situation-not-a-profile",
  },
  LINKEDIN_MESSAGE: {
    fr: "message-prospection-linkedin",
    en: "linkedin-prospecting-message",
  },
  MODJO_ALTERNATIVES: {
    fr: "alternative-a-modjo",
    en: "modjo-alternatives",
  },
  LEEXI_PRICING: {
    fr: "leexi-prix-fonctionnalites-limites",
    en: "leexi-pricing-features-limits",
  },
  FREE_CALL_ANALYSIS: {
    fr: "outil-analyse-appels-vente-gratuit",
    en: "free-sales-call-analysis-tool",
  },
  NETWORK_QUALIFICATION: {
    fr: "qualifier-son-reseau-linkedin",
    en: "qualify-your-linkedin-network",
  },
  CALL_RECORDING_GDPR: {
    fr: "enregistrer-appels-clients-rgpd",
    en: "record-customer-calls-gdpr",
  },
  SMALL_TEAM_CALL_ANALYSIS: {
    fr: "analyser-ses-appels-seul-petite-equipe",
    en: "analyse-calls-solo-small-team",
  },
  DISCOVERY_CALL: {
    fr: "appel-de-decouverte-questions",
    en: "discovery-call-questions",
  },
  LINKEDIN_LIMITS: {
    fr: "prospection-linkedin-limites-compte",
    en: "linkedin-prospecting-account-limits",
  },
  FOLLOW_UP_SEQUENCE: {
    fr: "relancer-sans-harceler-sequence",
    en: "follow-up-without-hounding",
  },
  OFFER_NOT_SELLING: {
    fr: "offre-qui-ne-se-vend-pas",
    en: "offer-that-does-not-sell",
  },
  AVATAR_VALIDATION: {
    fr: "verifier-son-avatar-client",
    en: "validate-your-client-avatar",
  },
  OFFER_PRICING: {
    fr: "fixer-le-prix-de-son-offre",
    en: "price-your-offer",
  },
  AVATAR_WITHOUT_CLIENTS: {
    fr: "definir-client-ideal-sans-clients",
    en: "define-ideal-customer-without-customers",
  },
  REPLY_TO_MEETING: {
    fr: "transformer-une-reponse-en-rendez-vous",
    en: "turn-a-reply-into-a-meeting",
  },
  SALES_NAVIGATOR: {
    fr: "sales-navigator-limites",
    en: "sales-navigator-limits",
  },
  BUYING_SIGNALS: {
    fr: "signaux-achat-prospection",
    en: "buying-signals-prospecting",
  },
} as const;

export const HelpPaths = {
  MCP: "/mcp",
  EXTENSION: "/extension",
} as const;

export const BrandPaths = {
  CHARTER: "/brand",
} as const;

export const ProtectedPaths = {
  CALL_ANALYSIS: "/call-analysis",
  OFFERS: "/offers",
  CLIENT_AVATAR: "/client-avatar",
  PROSPECT_SEARCH: "/prospect-search",
  MESSAGES_CONTENT: "/messages-content",
  ADMINISTRATION: "/administration",
  PROJECT: "/project",
} as const;

export const ToolLandingPaths = {
  CALL_ANALYSIS: ProtectedPaths.CALL_ANALYSIS,
  OFFERS: ProtectedPaths.OFFERS,
  CLIENT_AVATAR: ProtectedPaths.CLIENT_AVATAR,
  PROSPECT_SEARCH: ProtectedPaths.PROSPECT_SEARCH,
  MESSAGES_CONTENT: ProtectedPaths.MESSAGES_CONTENT,
} as const;

export const SitemapRoutes = { ...PublicPaths, ...HelpPaths, ...ToolLandingPaths };

export const Routes = {
  HOME: APP_URL_PREFIX,
  BLOG: `${APP_URL_PREFIX}${PublicPaths.BLOG}`,
  PRIVACY: `${APP_URL_PREFIX}${LegalPaths.PRIVACY}`,
  TERMS: `${APP_URL_PREFIX}${LegalPaths.TERMS}`,
  MCP_GUIDE: `${APP_URL_PREFIX}${HelpPaths.MCP}`,
  EXTENSION_GUIDE: `${APP_URL_PREFIX}${HelpPaths.EXTENSION}`,
  PROTECTED: {
    CALL_ANALYSIS: `${APP_URL_PREFIX}${ProtectedPaths.CALL_ANALYSIS}`,
    OFFERS: `${APP_URL_PREFIX}${ProtectedPaths.OFFERS}`,
    CLIENT_AVATAR: `${APP_URL_PREFIX}${ProtectedPaths.CLIENT_AVATAR}`,
    PROSPECT_SEARCH: `${APP_URL_PREFIX}${ProtectedPaths.PROSPECT_SEARCH}`,
    MESSAGES_CONTENT: `${APP_URL_PREFIX}${ProtectedPaths.MESSAGES_CONTENT}`,
    ADMINISTRATION: `${APP_URL_PREFIX}${ProtectedPaths.ADMINISTRATION}`,
    ADMIN_USER: (uuid: string) =>
      `${APP_URL_PREFIX}${ProtectedPaths.ADMINISTRATION}?${UrlParam.TAB}=${AdministrationTab.USERS}&${UrlParam.USER}=${uuid}`,
    PROJECT: (uuid: string) => `${APP_URL_PREFIX}${ProtectedPaths.PROJECT}/${uuid}`,
  },
};
